import { localTime } from '@naturalcycles/js-lib';
export function formatMetaClickId(clickId) {
  if (clickId === undefined) {
    return clickId;
  }
  // https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc/
  // fbc = version.subdomainIndex.creationTime.<fbclid>
  if (clickId.startsWith('fb.')) {
    // fbclid is already formatted
    return clickId;
  }
  return `fb.1.${localTime.nowUnixMillis()}.${clickId}`;
}